import { render, staticRenderFns } from "./AudioResource.vue?vue&type=template&id=4f657ea3&scoped=true&"
import script from "./AudioResource.vue?vue&type=script&lang=js&"
export * from "./AudioResource.vue?vue&type=script&lang=js&"
import style0 from "./AudioResource.vue?vue&type=style&index=0&id=4f657ea3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f657ea3",
  null
  
)

export default component.exports